import React from "react";

function SuitcaseSearchIcon({ size = "24" }) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={size}
			height={size}
			fill="none"
			viewBox="0 0 24 24"
		>
			<path
				fill="#8C8594"
				d="M13.667 7V5.333h-3.334V7h3.334zM5.333 9.5V17c0 .458.375.833.834.833h11.666a.836.836 0 00.834-.833V9.5a.836.836 0 00-.834-.833H6.167a.836.836 0 00-.834.833zM18.667 7a1.66 1.66 0 011.666 1.667v9.166a1.66 1.66 0 01-1.666 1.667H5.333a1.66 1.66 0 01-1.666-1.667l.008-9.166C3.675 7.742 4.408 7 5.333 7h3.334V5.333a1.66 1.66 0 011.666-1.666h3.334a1.66 1.66 0 011.666 1.666V7h3.334z"
			/>
		</svg>
	);
}

export default SuitcaseSearchIcon;
